import { useState, useRef, useEffect } from "react";
import styles from "./OTPPopup.module.css";

const OTPPopup = ({ show, onClose, onVerify, sendOtp }) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [restart, setRestart] = useState(false);

  useEffect(() => {
    if (!show) return;

    inputRefs.current[0]?.focus();

    // Start countdown
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [show, restart]);

  const resetTimer = () => {
    setTimer(30);
    setCanResend(false);
    setRestart((prev) => !prev);
  };

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }

    if (index === 3 && value) {
      handleSubmit();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").slice(0, 4);
    if (/^\d{4}$/.test(pasteData)) {
      const newOtp = pasteData.split("");
      setOtp(newOtp);
      inputRefs.current[3]?.focus();
    }
  };

  const handleSubmit = () => {
    const otpCode = otp.join("");
    if (otpCode.length === 4) {
      onVerify(otpCode);
    }
  };

  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <button className={styles.closeBtn} onClick={onClose}>
          &times;
        </button>

        <div className={styles.content}>
          <h2 className={styles.title}>Verify OTP</h2>
          <p className={styles.subtitle}>
            Enter the 4-digit code sent to your device
          </p>

          <div className={styles.otpContainer}>
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
                className={styles.otpInput}
                autoComplete="one-time-code"
              />
            ))}
          </div>

          <div className={styles.timer}>
            {!canResend ? (
              <span>00:{timer.toString().padStart(2, "0")}</span>
            ) : (
              <button
                className={styles.resendBtn}
                onClick={() => {
                  sendOtp();
                  resetTimer();
                }}
              >
                Resend Code
              </button>
            )}
          </div>

          <button
            className={styles.verifyBtn}
            onClick={handleSubmit}
            disabled={otp.join("").length !== 4}
          >
            Verify
          </button>
        </div>

        {/* <div className={styles.footer}>
          <p>
            Didn't receive code? <span>Contact Support</span>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default OTPPopup;
